$(".custom-testimonial-slider").slick({
  centerMode: true,
  infinite: true,
  slidesToScroll: 1,
  draggable: false,
  variableWidth: true,
});

$(".collection-review-slider").slick({
  infinite: false,
  accesibility: false,
  draggable: false,
  swipe: false,
  touchMove: false,
  prevArrow:
    '<svg width="20" class="slick-arrow slick-prev" height="31" viewBox="0 0 20 31" fill="none"><path d="M1.32143 15.99L18.6786 29.8995" stroke="#582200" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M18.6786 1.5457L1.32143 15.4552" stroke="#582200" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
  nextArrow:
    '<svg width="20" class="slick-arrow slick-next" height="31" viewBox="0 0 20 31" fill="none"><path d="M18.6786 15.01L1.32143 1.1005" stroke="#582200" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M1.32143 29.4543L18.6786 15.5448" stroke="#582200" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
});

$(".flip-slider").slick({
  centerMode: true,
  infinite: true,
  slidesToScroll: 1,
  slidesToShow: 5,
  dots: true,
  variableWidth: true,
});

$(".collection-review-slider").on(
  "afterChange",
  function (event, slick, currentSlide, nextSlide) {
    var slickObj = $(".collection-review-slider");
    var slideCount = slickObj.slick("getSlick").slideCount;
    if (currentSlide === slideCount - 1) {
      slickObj.slick("slickGoTo", 0);
    }
  }
);
document.querySelectorAll(".testimonial-arrows button").forEach(function (ele) {
  ele.addEventListener("click", function () {
    if (this.classList.contains("btn-next")) {
      $(".custom-testimonial-slider").slick("slickNext");
    } else {
      $(".custom-testimonial-slider").slick("slickPrev");
    }
  });
});
document.querySelectorAll(".info-title svg").forEach(function (ele) {
  ele.addEventListener("click", function () {
    let tEle = this.parentNode.querySelector("info");
    console.log(tEle);
    if (this.classList.contains("show-info")) {
      this.classList.remove("show-info");
      tEle.style.opacity = "0";
      tEle.style.height = "0px";
      tEle.style.padding = "0px";
    } else {
      this.classList.add("show-info");
      tEle.style.opacity = "1";
      tEle.style.height = "100%";
      tEle.style.padding = "1rem 2rem";
    }
  });
});

// flip
document.querySelectorAll(".ctm-other-info-btn").forEach(function (ele) {
  ele.addEventListener("click", function () {
    this.closest(".card-product-main").classList.remove("card-product-fornt");
    this.closest(".card-product-main").classList.add("card-product-back");
  });
});

document.querySelectorAll(".ctm-card-back-main").forEach(function (ele) {
  ele.addEventListener("click", function () {
    this.closest(".card-product-main").classList.remove("card-product-back");
    this.closest(".card-product-main").classList.add("card-product-fornt");
  });
});

if (document.querySelector("button.be-seller")) {
  document
    .querySelector("button.be-seller")
    .addEventListener("click", function () {
      let scr = document.querySelector(".best-seller").offsetTop;
      window.scrollTo(0, scr);
    });
}

var mediaSize = $(".product-custom-media").data("media");
var dostTrue = false;
if (mediaSize > 1) {
  var dostTrue = true;
}
$(".product-custom-media").slick({
  infinite: true,
  accesibility: false,
  draggable: false,
  swipe: false,
  touchMove: false,
  autoplay: true,
  autoplaySpeed: 5000,
  speed: 1000,
  loop: true,
  dots: dostTrue,
  arrows: false,
  adaptiveHeight: true,
});
// $(".product-custom-media").on(
//   "afterChange",
//   function (event, slick, currentSlide, nextSlide) {
//     var slickObj = $(".product-custom-media");
//     var slideCount = slickObj.slick("getSlick").slideCount;
//     if (currentSlide === slideCount - 1) {
//       setTimeout(() => {
//         slickObj.slick("slickGoTo", 0);
//       }, 2800);
//       setTimeout(() => {
//         slickObj.slick("refresh");
//       }, 3300);
//     }
//   }
// );

document.querySelectorAll(".poi-title").forEach(function (ele) {
  ele.addEventListener("click", function () {
    if (ele.classList.contains("active")) {
      ele.classList.remove("active");
      ele
        .closest(".product-other-info")
        .querySelector(".poi-des").style.height = "0px";
    } else {
      document.querySelectorAll(".poi-des").forEach(function (ele) {
        ele.style.height = "0px";
      });
      document.querySelectorAll(".poi-title").forEach(function (ele) {
        ele.classList.remove("active");
      });
      ele.classList.add("active");
      let getHeight = ele
        .closest(".product-other-info")
        .querySelector(".poi-get").offsetHeight;
      console.log(getHeight);
      // getHeight = getHeight + 20;
      ele
        .closest(".product-other-info")
        .querySelector(".poi-des").style.height = getHeight + "px";
    }
  });
});

document.querySelectorAll(".iwi-info-text").forEach(function (ele) {
  ele.addEventListener("click", function name(params) {
    if (!this.classList.contains("custom_item-grid")) {
      document.querySelectorAll(".iwi-info-text").forEach(function (e) {
        e.classList.remove("info-on");
      });
      ele.classList.add("info-on");
    }
  });
});
if (document.querySelector(".image-with-info-dec")) {
  document
    .querySelector(".image-with-info-dec")
    .addEventListener("mousemove", (event) => {
      let left = event.screenX;
      let top = event.screenY;
      let noLeft =
        document.querySelector(".image-with-info-dec").clientWidth -
        document.querySelector(".scroll-info").clientWidth;
      if (left > noLeft) {
        document.querySelector(".scroll-info").style.left = noLeft + "px";
      } else {
        document.querySelector(".scroll-info").style.left = left + "px";
      }
      document.querySelector(".scroll-info").style.top = top + "px";
    });
  document
    .querySelector(".image-with-info-wrapper .scrolling-banner")
    .addEventListener("mouseover", (event) => {
      document.querySelector(".scroll-info").style.display = "block";
    });
  document
    .querySelector(".image-with-info-wrapper .scrolling-banner")
    .addEventListener("mouseleave", (event) => {
      document.querySelector(".scroll-info").style.display = "none";
    });
}

window.addEventListener("scroll", waveAnimation);

let waveOn = 0;
function waveAnimation() {
  if (document.querySelector(".custom-testimonial-heder")) {
    let scrollOffset =
      document.querySelector(".custom-testimonial-heder").offsetTop -
      window.innerHeight;
    if (scrollOffset < pageYOffset) {
      waveOn = waveOn + 1;
      if (waveOn == 1) {
        console.log(scrollOffset, waveOn);
        var timeline = gsap.timeline();
        timeline.fromTo(
          "#masterPath1",
          { attr: { startOffset: "0%" } },
          { attr: { startOffset: "-120%" }, duration: 30, ease: "none" }
        );
        timeline.play();
        setTimeout(function () {
          var timeline2 = gsap.timeline();
          timeline2.fromTo(
            "#masterPath2",
            { attr: { startOffset: "100%" } },
            { attr: { startOffset: "-120%" }, duration: 55, ease: "none" }
          );
          timeline2.repeat(-1);
          timeline2.play();
        }, 2550);

        setTimeout(function () {
          var timeline3 = gsap.timeline();
          timeline3.fromTo(
            "#masterPath1",
            { attr: { startOffset: "100%" } },
            { attr: { startOffset: "-120%" }, duration: 55, ease: "none" }
          );
          timeline3.repeat(-1);
          timeline3.play();
        }, 30100);
      }
    }
  }
}

function colSliderOn() {
  if ($(window).width() < 769) {
    if (
      !$(".ctm-featured-collection ul.product-grid").hasClass(
        "slick-initialized"
      )
    ) {
      $(".ctm-featured-collection ul.product-grid").slick({
        infinite: false,
        dots: true,
        arrows: false,
        slidesToShow: 1.2,
      });
    }
  } else {
    $(".ctm-featured-collection ul.product-grid").slick("unslick");
  }
}
colSliderOn();
function reportWindowSize() {
  colSliderOn();
}
window.onresize = reportWindowSize;

document.querySelectorAll("span.ctm-card-info").forEach(function (ele) {
  ele.addEventListener("click", function () {
    this.closest(".pro-rot-main").classList.add("pro-rot-back");
  });
});
document.querySelectorAll(".pcb-close svg").forEach(function (ele) {
  ele.addEventListener("click", function () {
    this.closest(".pro-rot-main").classList.remove("pro-rot-back");
  });
});
$(".custom-f-collection-wrapper").removeClass('hide');
$(".custom-f-collection-main-row").slick({
  dots: false,
  infinite: false,
  speed: 300,
  arrows: true,
  prevArrow:
    '<svg width="50" height="51" viewBox="0 0 50 51" fill="none" data-role="none" class="slick-arrow slick-prev"  style="display: block;"><g clip-path="url(#clip0_260_1916)"><path d="M21.6349 18.2959C21.9252 17.9953 22.4091 17.9953 22.7098 18.2959C23.0001 18.5863 23.0001 19.0702 22.7098 19.3598L17.2579 24.8117H35.2477C35.6671 24.8117 36 25.1459 36 25.5653C36 25.9846 35.6671 26.3285 35.2477 26.3285H17.2585L22.7104 31.7701C23.0007 32.0707 23.0007 32.5553 22.7104 32.8449C22.4097 33.1456 21.9252 33.1456 21.6355 32.8449L14.8933 26.1027C14.5926 25.8124 14.5926 25.3285 14.8933 25.0382L21.6349 18.2959Z" fill="#582200"></path></g><rect x="-0.5" y="0.5" width="49" height="49" rx="24.5" transform="matrix(-1 0 0 1 49 0.0700684)" stroke="#582200"></rect><defs><clipPath id="clip0_260_1916"><rect width="21.3332" height="15" fill="white" transform="matrix(-1 0 0 1 36 18.0701)"></rect></clipPath></defs></svg>',
  nextArrow:
    '<svg width="50" height="51" viewBox="0 0 50 51" fill="none" data-role="none" class="slick-arrow slick-next"  style="display: block;"><g clip-path="url(#clip0_260_1919)"><path d="M28.3651 18.2959C28.0748 17.9953 27.5909 17.9953 27.2902 18.2959C26.9999 18.5863 26.9999 19.0702 27.2902 19.3598L32.7421 24.8117H14.7523C14.3329 24.8117 14 25.1459 14 25.5653C14 25.9846 14.3329 26.3285 14.7523 26.3285H32.7415L27.2896 31.7701C26.9993 32.0707 26.9993 32.5553 27.2896 32.8449C27.5903 33.1456 28.0748 33.1456 28.3645 32.8449L35.1067 26.1027C35.4074 25.8124 35.4074 25.3285 35.1067 25.0382L28.3651 18.2959Z" fill="#582200"></path></g><rect x="0.5" y="0.570068" width="49" height="49" rx="24.5" stroke="#582200"></rect><defs><clipPath id="clip0_260_1919"><rect width="21.3332" height="15" fill="white" transform="translate(14 18.0701)"></rect></clipPath></defs></svg>',
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1320,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2.1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: true,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      },
    },
  ],
});


// read more content
if (document.querySelector("p.con-sign-up-text span.cst-more")) {
  document
    .querySelector("p.con-sign-up-text span.cst-more")
    .addEventListener("click", function () {
      if (this.classList.contains("m-active")) {
        this.classList.remove("m-active");
        this.textContent = "See more.";
        document.querySelector(".con-more-content").style.display = "none";
      } else {
        this.classList.add("m-active");
        this.textContent = "See less.";
        document.querySelector(".con-more-content").style.display = "flex";
      }
    });
}

// faq section
if (document.querySelectorAll(".faq-acc-title").length) {
  document.querySelectorAll(".faq-acc-title").forEach(function (ele) {
    ele.addEventListener("click", function () {
      let acc = ele.closest(".faq-acc-main");
      if (acc.classList.contains("acc-active")) {
        acc.classList.remove("acc-active");
      } else {
        acc.classList.add("acc-active");
      }
    });
  });
}

// check sold out

function checkVariants(variant, self) {
  let varId = null;
  self
    .closest(".caop-col")
    .querySelectorAll(".caop-variant-select option")
    .forEach(function (ele) {
      if (ele.textContent == variant) {
        varId = ele.value;
        return false;
      }
    });
  console.log(varId);
  return varId;
}

// cart add on product add to cart
window.cartAddOns = function () {
  document.querySelectorAll("[ctm-add-btn]").forEach(function (ele) {
    ele.addEventListener("click", function (evt) {
      evt.preventDefault();
      let doBox = false;
      if (this.classList.contains("imp-box-btn")) {
        doBox = true;
      }
      this.classList.add("load");
      let id = this.dataset.id;
      window.customAddToCart(id, 1, doBox);
    });
  });
};
window.cartAddOns();

function addOnVariants() {
  document
    .querySelectorAll(".caop-col-colors-main input")
    .forEach(function (ele) {
      ele.addEventListener("change", function () {
        let sOpt = this.closest(".caop-col").querySelector(
          ".caop-col-size-main select"
        ).value;
        let fOpt = this.value;
        let variant = fOpt + " / " + sOpt;
        let varId = checkVariants(variant, this);
        if (varId != null) {
          this.closest(".caop-col")
            .querySelector("button[ctm-add-btn]")
            .setAttribute("disabled", false);
          this.closest(".caop-col")
            .querySelector("button[ctm-add-btn]")
            .setAttribute("data-id", varId);
        } else {
          this.closest(".caop-col")
            .querySelector("button[ctm-add-btn]")
            .setAttribute("disabled", true);
        }
      });
    });
  document
    .querySelectorAll(".caop-col-size-main select")
    .forEach(function (ele) {
      ele.addEventListener("change", function () {
        let fOpt = this.closest(".caop-col").querySelector(
          ".caop-col-colors-main input:checked"
        ).value;
        let sOpt = this.value;
        let variant = fOpt + " / " + sOpt;
        let varId = checkVariants(variant, this);
        console.log(
          this.closest(".caop-col").querySelector("button[ctm-add-btn]")
        );
        if (varId != null) {
          this.closest(".caop-col")
            .querySelector("button[ctm-add-btn]")
            .removeAttribute("disabled");
          this.closest(".caop-col")
            .querySelector("button[ctm-add-btn]")
            .setAttribute("data-id", varId);
        } else {
          this.closest(".caop-col")
            .querySelector("button[ctm-add-btn]")
            .setAttribute("disabled", true);
        }
      });
    });
  window.cartAddOns();
}
addOnVariants();

// custom add to cart
window.customAddToCart = function (id, quantity, doBox) {
  let cart =
    document.querySelector("cart-notification") ||
    document.querySelector("cart-drawer");
  let data = {
    id: id,
    quantity: quantity,
    sections: cart.getSectionsToRender().map((section) => section.id),
    sections_url: window.location.pathname,
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then((response) => response.json())
    .then((response) => {
      if (cart) {
        cart.renderContents(response, doBox);
      } else {
        window.location = window.routes.cart_url;
      }
    })
    .catch((error) => {
      console.error("Error adding bundle to cart:", error);
    });
};

// build box widget

var build_box_cls = document.querySelector("button.build-box-w-cls");
if(build_box_cls){
  build_box_cls.addEventListener("click", function () {
    if (
      document
        .querySelector(".build-box-widget-main")
        .classList.contains("shirnk")
    ) {
      document.querySelector(".build-box-w-btn").style.opacity = "1";
      document
        .querySelector(".build-box-widget-main")
        .classList.remove("shirnk");
    } else {
      document.querySelector(".build-box-w-btn").style.opacity = "0";
      document.querySelector(".build-box-widget-main").classList.add("shirnk");
    }
  });
}

var build_box_btn_button_btn_check = document.querySelector(".build-box-w-btn button.btn");
if(build_box_btn_button_btn_check){
  build_box_btn_button_btn_check.addEventListener("click", function () {
    if (document.querySelector(".build-box-widget-main.in-cart")) {
      document.querySelector("a#cart-icon-bubble").click();
    } else {
      buildBoxInit();
      document.body.classList.add("build-box-on");
    }
  });
}

var build_box_img = document.querySelector(".build-box-w-img img")
if(build_box_img){
build_box_img.addEventListener("click", function () {
    if (
      document
        .querySelector(".build-box-widget-main")
        .classList.contains("shirnk")
    ) {
      if (
        document.querySelector("div#CartDrawer .build-box-main") &&
        !document.querySelector("cart-drawer.drawer.is-empty")
      ) {
        document.querySelector("a#cart-icon-bubble").click();
      } else {
        buildBoxInit();
        document.body.classList.add("build-box-on");
      }
    } else {
      document.querySelector("button.build-box-w-cls").click();
    }
  });
}

// quickAdd
// function quickAdd() {
//   function removeShowQuickClass() {
//     document.querySelectorAll(".card_quick_variant").forEach(function (ele) {
//       ele.classList.remove("show_quick");
//     });
//   }
//   document.querySelectorAll(".quick_addbtn").forEach(function (ele) {
//     ele.addEventListener("click", function () {
//       removeShowQuickClass();
//       if (this.closest(".card_quick_variant")) {
//         this.closest(".card_quick_variant").classList.add("show_quick");
//       }
//       var optionOneInputs = this.closest(".no-js-hidden").querySelectorAll(
//         '.field_variant[data-index="option-1"] input:checked'
//       );
//       if (optionOneInputs) {
//         var optionOneVal = "";
//         if (optionOneInputs.length > 0) {
//           optionOneVal = optionOneInputs[0].value;
//         }
//         if (optionOneVal) {
//           var option_2_select = this.closest(".no-js-hidden").querySelectorAll(
//             '.field_variant[data-index="option-2"]'
//           ).length;
//           if (option_2_select === 1) {
//             var option_2_select_v = this.closest(".no-js-hidden").querySelector(
//               '.field_variant[data-index="option-2"] input:checked'
//             ).value;
//             var combination = optionOneVal + " / " + option_2_select_v;
//             var variant_id = this.closest(".no-js-hidden").querySelector(
//               '.product_variant-hidden option[data-title="' + combination + '"]'
//             ).value;
//             this.closest(".no-js-hidden").querySelector(
//               ".product_variant-hidden select"
//             ).value = variant_id;
//             this.closest(".no-js-hidden")
//               .querySelector(".product_variant-hidden select")
//               .dispatchEvent(new Event("change"));
//             var quickAddBtn =
//               this.closest(".no-js-hidden").querySelector('input[name="id"]');
//             quickAddBtn.setAttribute("value", variant_id);

//             var inputs = this.closest(".no-js-hidden").querySelectorAll(
//               '.field_variant[data-index="option-2"] label'
//             );
//             inputs.forEach(function (input) {
//               input.classList.add("is-disabled");
//             });
//             this.closest(".no-js-hidden")
//               .querySelectorAll(
//                 ".product_variant-hidden select option[available]"
//               )
//               .forEach(function (option) {
//                 var valueTitle = option.getAttribute("data-title");
//                 var setValue = valueTitle.split(" / ")[0];
//                 if (setValue === optionOneVal) {
//                   var avlValue = valueTitle.split(" / ")[1];
//                   var labels = document.querySelectorAll(
//                     '.field_variant[data-index="option-2"] input[value="' +
//                       avlValue +
//                       '"]+label'
//                   );
//                   labels.forEach(function (label) {
//                     label.classList.remove("is-disabled");
//                   });
//                 }
//               });
//           } else {
//             var variant_id = this.closest(".no-js-hidden").querySelector(
//               '.product_variant-hidden option[data-title="' +
//                 optionOneVal +
//                 '"]'
//             ).value;
//             this.closest(".no-js-hidden").querySelector(
//               ".product_variant-hidden select"
//             ).value = variant_id;
//             this.closest(".no-js-hidden")
//               .querySelector(".product_variant-hidden select")
//               .dispatchEvent(new Event("change"));
//             var quickAddBtn = event.target
//               .closest(".no-js-hidden")
//               .querySelector('input[name="id"]');
//             quickAddBtn.setAttribute("value", variant_id);
//           }
//         }
//       }
//       var optionTwoInputs = this.closest(".no-js-hidden").querySelectorAll(
//         '.field_variant[data-index="option-2"] input:checked'
//       );
//       if (optionTwoInputs) {
//         var optionTwoVal = "";
//         if (optionTwoInputs.length > 0) {
//           optionTwoVal = optionTwoInputs[0].value;
//         }
//         if (optionTwoVal) {
//           var option_2_select = this.closest(".no-js-hidden").querySelectorAll(
//             '.field_variant[data-index="option-1"]'
//           ).length;
//           if (option_2_select === 1) {
//             var option_2_select_v = this.closest(".no-js-hidden").querySelector(
//               '.field_variant[data-index="option-1"] input:checked'
//             ).value;
//             var combination = option_2_select_v + " / " + optionTwoVal;
//             var variant_id = this.closest(".no-js-hidden").querySelector(
//               '.product_variant-hidden option[data-title="' + combination + '"]'
//             ).value;
//             this.closest(".no-js-hidden").querySelector(
//               ".product_variant-hidden select"
//             ).value = variant_id;
//             this.closest(".no-js-hidden")
//               .querySelector(".product_variant-hidden select")
//               .dispatchEvent(new Event("change"));
//             var quickAddBtn =
//               this.closest(".no-js-hidden").querySelector('input[name="id"]');
//             quickAddBtn.setAttribute("value", variant_id);

//             var inputs = this.closest(".no-js-hidden").querySelectorAll(
//               '.field_variant[data-index="option-1"] label'
//             );
//             inputs.forEach(function (input) {
//               input.classList.add("is-disabled");
//             });
//             this.closest(".no-js-hidden")
//               .querySelectorAll(
//                 ".product_variant-hidden select option[available]"
//               )
//               .forEach(function (option) {
//                 var valueTitle = option.getAttribute("data-title");
//                 var setValue = valueTitle.split(" / ")[1];
//                 if (setValue === optionTwoVal) {
//                   var avlValue = valueTitle.split(" / ")[0];
//                   var labels = document.querySelectorAll(
//                     '.field_variant[data-index="option-1"] input[value="' +
//                       avlValue +
//                       '"]+label'
//                   );
//                   labels.forEach(function (label) {
//                     label.classList.remove("is-disabled");
//                   });
//                 }
//               });
//           } else {
//             var variant_id = this.closest(".no-js-hidden").querySelector(
//               '.product_variant-hidden option[data-title="' +
//                 optionTwoVal +
//                 '"]'
//             ).value;
//             this.closest(".no-js-hidden").querySelector(
//               ".product_variant-hidden select"
//             ).value = variant_id;
//             this.closest(".no-js-hidden")
//               .querySelector(".product_variant-hidden select")
//               .dispatchEvent(new Event("change"));
//             var quickAddBtn =
//               this.closest(".no-js-hidden").querySelector('input[name="id"]');
//             quickAddBtn.setAttribute("value", variant_id);
//           }
//         }
//       }
//     });
//   });

//   document.addEventListener("change", function (event) {
//     if (!event.target.matches('.field_variant[data-index="option-1"] input'))
//       return;

//     var this_v = event.target.value;
//     var option_2_select = event.target
//       .closest(".no-js-hidden")
//       .querySelectorAll('.field_variant[data-index="option-2"]').length;

//     if (option_2_select === 1) {
//       var option_2_select_v = event.target
//         .closest(".no-js-hidden")
//         .querySelector(
//           '.field_variant[data-index="option-2"] input:checked'
//         ).value;
//       var combination = this_v + " / " + option_2_select_v;
//       var variant_id = event.target
//         .closest(".no-js-hidden")
//         .querySelector(
//           '.product_variant-hidden option[data-title="' + combination + '"]'
//         ).value;
//       var variant_price = event.target
//         .closest(".no-js-hidden")
//         .querySelector(
//           '.product_variant-hidden option[data-title="' + combination + '"]'
//         ).dataset.price;
//       variant_price = moneyFormate(variant_price);
//       event.target
//         .closest(".ctm-product-card_new")
//         .querySelector(".price__regular span.price-item--regular").textContent =
//         variant_price;
//       event.target
//         .closest(".no-js-hidden")
//         .querySelector(".product_variant-hidden select").value = variant_id;
//       event.target
//         .closest(".no-js-hidden")
//         .querySelector(".product_variant-hidden select")
//         .dispatchEvent(new Event("change"));
//       var quickAddBtn = event.target
//         .closest(".no-js-hidden")
//         .querySelector('input[name="id"]');
//       quickAddBtn.setAttribute("value", variant_id);

//       var inputs = event.target
//         .closest(".no-js-hidden")
//         .querySelectorAll('.field_variant[data-index="option-2"] label');
//       inputs.forEach(function (input) {
//         input.classList.add("is-disabled");
//       });
//       event.target
//         .closest(".no-js-hidden")
//         .querySelectorAll(".product_variant-hidden select option[available]")
//         .forEach(function (option) {
//           var valueTitle = option.getAttribute("data-title");
//           var setValue = valueTitle.split(" / ")[0];
//           if (setValue === this_v) {
//             var avlValue = valueTitle.split(" / ")[1];
//             var labels = document.querySelectorAll(
//               '.field_variant[data-index="option-2"] input[value="' +
//                 avlValue +
//                 '"]+label'
//             );
//             labels.forEach(function (label) {
//               label.classList.remove("is-disabled");
//             });
//           }
//         });
//     } else {
//       var variant_id = event.target
//         .closest(".no-js-hidden")
//         .querySelector(
//           '.product_variant-hidden option[data-title="' + this_v + '"]'
//         ).value;
//       event.target
//         .closest(".no-js-hidden")
//         .querySelector(".product_variant-hidden select").value = variant_id;
//       event.target
//         .closest(".no-js-hidden")
//         .querySelector(".product_variant-hidden select")
//         .dispatchEvent(new Event("change"));
//       var quickAddBtn = event.target
//         .closest(".no-js-hidden")
//         .querySelector('input[name="id"]');
//       quickAddBtn.setAttribute("value", variant_id);
//     }
//   });

//   document.addEventListener("change", function (event) {
//     if (!event.target.matches('.field_variant[data-index="option-2"] input'))
//       return;

//     var this_v = event.target.value;
//     var option_2_select = event.target
//       .closest(".no-js-hidden")
//       .querySelectorAll('.field_variant[data-index="option-1"]').length;

//     if (option_2_select === 1) {
//       var option_2_select_v = event.target
//         .closest(".no-js-hidden")
//         .querySelector(
//           '.field_variant[data-index="option-1"] input:checked'
//         ).value;
//       var combination = option_2_select_v + " / " + this_v;
//       var variant_id = event.target
//         .closest(".no-js-hidden")
//         .querySelector(
//           '.product_variant-hidden option[data-title="' + combination + '"]'
//         ).value;
//       var variant_price = event.target
//         .closest(".no-js-hidden")
//         .querySelector(
//           '.product_variant-hidden option[data-title="' + combination + '"]'
//         ).dataset.price;
//       variant_price = moneyFormate(variant_price);
//       event.target
//         .closest(".ctm-product-card_new")
//         .querySelector(".price__regular span.price-item--regular").textContent =
//         variant_price;
//       event.target
//         .closest(".no-js-hidden")
//         .querySelectorAll(".product_variant-hidden select")
//         .forEach(function (select) {
//           select.value = variant_id;
//           select.dispatchEvent(new Event("change"));
//         });
//       var quickAddBtn = event.target
//         .closest(".no-js-hidden")
//         .querySelector('input[name="id"]');
//       quickAddBtn.setAttribute("value", variant_id);

//       var inputs = event.target
//         .closest(".no-js-hidden")
//         .querySelectorAll('.field_variant[data-index="option-1"] label');
//       inputs.forEach(function (input) {
//         input.classList.add("is-disabled");
//       });
//       event.target
//         .closest(".no-js-hidden")
//         .querySelectorAll(".product_variant-hidden select option[available]")
//         .forEach(function (option) {
//           var valueTitle = option.getAttribute("data-title");
//           var setValue = valueTitle.split(" / ")[1];
//           if (setValue === this_v) {
//             var avlValue = valueTitle.split(" / ")[0];
//             var labels = document.querySelectorAll(
//               '.field_variant[data-index="option-1"] input[value="' +
//                 avlValue +
//                 '"]+label'
//             );
//             labels.forEach(function (label) {
//               label.classList.remove("is-disabled");
//             });
//           }
//         });
//     } else {
//       var variant_id = event.target
//         .closest(".no-js-hidden")
//         .querySelectorAll(
//           '.product_variant-hidden option[data-title="' + this_v + '"]'
//         ).value;
//       event.target
//         .closest(".no-js-hidden")
//         .querySelectorAll(".product_variant-hidden select")
//         .forEach(function (select) {
//           select.value = variant_id;
//           select.dispatchEvent(new Event("change"));
//         });
//       var quickAddBtn = event.target
//         .closest(".no-js-hidden")
//         .querySelector('input[name="id"]');
//       quickAddBtn.setAttribute("value", variant_id);
//     }
//   });
// }
// quickAdd();

// $(document).mouseup(function (e) {
//   var container = $(".quick-add");
//   if (!container.is(e.target) && container.has(e.target).length === 0) {
//     if ($(".card_quick_variant ").hasClass("show_quick")) {
//       $(".card_quick_variant").removeClass("show_quick");
//     }
//   }
// });

//quick add

// $(document).find('.custom-rec-product li.grid__item_new').each(function(){
//   var selectedValue = $(this).find('.card_quick_variant .field_variant input').val();
//   //console.log(selectedValue,'selectedValue');
//   $(this).find('.product_variant-hidden select option.available').each(function(){
//     var selectOptionAttr = $(this).attr('data-title');
//     if(selectOptionAttr == selectedValue){
//       var selectOptionVal = $(this).val();
//       $(this).closest('.custom-rec-product li.grid__item_new').find('product-form input.product-variant-id[name="id"]').val(selectOptionVal);
//     }
//   });
  
// });

// sort by
$(document).on("click", ".new_sort .facets_label", function () {
  $(document).find(".dropList").toggle();
  $(this).toggleClass("show_list");
});

$(document).mouseup(function (e) {
  var container = $(".new_sort .facets_label,.dropList");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $(".dropList").hide();
    if ($(".new_sort .facets_label").hasClass("show_list")) {
      $(".new_sort .facets_label").removeClass("show_list");
    }
  }
});

document.addEventListener("change", function (event) {
  if (!event.target.matches('.field_sort input[type="radio"]')) return;
  var this_value = event.target.value;
  var text_value = event.target.getAttribute("data-title");
  event.target
    .closest(".facets__form")
    .querySelector(".facet-filters__sort").value = this_value;
  event.target
    .closest(".facets__form")
    .querySelector(".facet-filters__sort")
    .dispatchEvent(new Event("change"));
  event.target
    .closest(".facets__form")
    .querySelector(".sort_result").innerText = text_value;
});

$(document).on("click", ".custom_filter", function () {
  $(this).addClass("menu-opening");
});

$(document).mouseup(function (e) {
  var container = $(".mobile-facets__inner");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $(".custom_filter").removeClass("menu-opening");
  }
});

$(document).on("click", ".mobile-facets__close_new", function () {
  setTimeout(function () {
    $(document).find(".custom_filter").removeClass("menu-opening");
  }, 500);
});

document.addEventListener("change", function (event) {
  if (!event.target.matches('.field_sort_new input[type="radio"]')) return;
  var this_value = event.target.value;
  var text_value = event.target.getAttribute("data-title");
  console.log(text_value);
  event.target
    .closest(".mobile-facets")
    .querySelector(".mobile-facets__sort .select__select").value = this_value;
  event.target
    .closest(".mobile-facets")
    .querySelector(".mobile-facets__sort .select__select")
    .dispatchEvent(new Event("change"));
});

// =====blog-categories-list========//
const tabButton = document.querySelectorAll(
  ".article__tabs_list button.article__tabs_button"
);
const tabContent = document.querySelectorAll(".article_tab--content");
tabButton.forEach(function (element) {
  element.addEventListener("click", function () {
    var dataId = element.getAttribute("data-id");
    var elementId = document.getElementById(dataId);
    tabButton.forEach(function (button) {
      button.classList.remove("is--active");
    });
    element.classList.add("is--active");
    tabContent.forEach(function (eleContent) {
      eleContent.classList.remove("is--active");
    });
    elementId.classList.add("is--active");
  });
});
// =====article source button ========//
const sourceButton = document.querySelector("button.articleSourceButton");
const sourcContent = document.querySelector("#article__paragrapSource");
if (sourceButton != undefined || sourcContent != undefined) {
  sourceButton.addEventListener("click", function () {
    if (
      sourceButton.classList.contains("is--active") ||
      sourcContent.classList.contains("is--active")
    ) {
      sourceButton.classList.remove("is--active");
      sourcContent.classList.remove("is--active");
      sourcContent.style.display = "none";
    } else {
      sourceButton.classList.add("is--active");
      sourcContent.classList.add("is--active");
      sourcContent.style.display = "block";
    }
  });
}

$(document).ready(function () {
  $(".blog-banner--hero_slide").slick({
    dots: false,
    infinite: false,
    speed: 300,
    arrows: true,
    prevArrow:
      '<svg width="50" height="51" viewBox="0 0 50 51" fill="none" data-role="none" class="slick-arrow slick-prev"  style="display: block;"><g clip-path="url(#clip0_260_1916)"><path d="M21.6349 18.2959C21.9252 17.9953 22.4091 17.9953 22.7098 18.2959C23.0001 18.5863 23.0001 19.0702 22.7098 19.3598L17.2579 24.8117H35.2477C35.6671 24.8117 36 25.1459 36 25.5653C36 25.9846 35.6671 26.3285 35.2477 26.3285H17.2585L22.7104 31.7701C23.0007 32.0707 23.0007 32.5553 22.7104 32.8449C22.4097 33.1456 21.9252 33.1456 21.6355 32.8449L14.8933 26.1027C14.5926 25.8124 14.5926 25.3285 14.8933 25.0382L21.6349 18.2959Z" fill="#582200"></path></g><rect x="-0.5" y="0.5" width="49" height="49" rx="24.5" transform="matrix(-1 0 0 1 49 0.0700684)" stroke="#582200"></rect><defs><clipPath id="clip0_260_1916"><rect width="21.3332" height="15" fill="white" transform="matrix(-1 0 0 1 36 18.0701)"></rect></clipPath></defs></svg>',
    nextArrow:
      '<svg width="50" height="51" viewBox="0 0 50 51" fill="none" data-role="none" class="slick-arrow slick-next"  style="display: block;"><g clip-path="url(#clip0_260_1919)"><path d="M28.3651 18.2959C28.0748 17.9953 27.5909 17.9953 27.2902 18.2959C26.9999 18.5863 26.9999 19.0702 27.2902 19.3598L32.7421 24.8117H14.7523C14.3329 24.8117 14 25.1459 14 25.5653C14 25.9846 14.3329 26.3285 14.7523 26.3285H32.7415L27.2896 31.7701C26.9993 32.0707 26.9993 32.5553 27.2896 32.8449C27.5903 33.1456 28.0748 33.1456 28.3645 32.8449L35.1067 26.1027C35.4074 25.8124 35.4074 25.3285 35.1067 25.0382L28.3651 18.2959Z" fill="#582200"></path></g><rect x="0.5" y="0.570068" width="49" height="49" rx="24.5" stroke="#582200"></rect><defs><clipPath id="clip0_260_1919"><rect width="21.3332" height="15" fill="white" transform="translate(14 18.0701)"></rect></clipPath></defs></svg>',
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [],
    adaptiveHeight: true,
    autoplay: true,
  });
  $(".blog--navbar__categories-list").slick({
    dots: false,
    infinite: false,
    speed: 300,
    arrows: true,
    prevArrow:
      '<svg width="50" height="51" viewBox="0 0 50 51" fill="none" data-role="none" class="slick-arrow slick-prev"  style="display: block;"><g clip-path="url(#clip0_260_1916)"><path d="M21.6349 18.2959C21.9252 17.9953 22.4091 17.9953 22.7098 18.2959C23.0001 18.5863 23.0001 19.0702 22.7098 19.3598L17.2579 24.8117H35.2477C35.6671 24.8117 36 25.1459 36 25.5653C36 25.9846 35.6671 26.3285 35.2477 26.3285H17.2585L22.7104 31.7701C23.0007 32.0707 23.0007 32.5553 22.7104 32.8449C22.4097 33.1456 21.9252 33.1456 21.6355 32.8449L14.8933 26.1027C14.5926 25.8124 14.5926 25.3285 14.8933 25.0382L21.6349 18.2959Z" fill="#582200"></path></g><rect x="-0.5" y="0.5" width="49" height="49" rx="24.5" transform="matrix(-1 0 0 1 49 0.0700684)" stroke="#582200"></rect><defs><clipPath id="clip0_260_1916"><rect width="21.3332" height="15" fill="white" transform="matrix(-1 0 0 1 36 18.0701)"></rect></clipPath></defs></svg>',
    nextArrow:
      '<svg width="50" height="51" viewBox="0 0 50 51" fill="none" data-role="none" class="slick-arrow slick-next"  style="display: block;"><g clip-path="url(#clip0_260_1919)"><path d="M28.3651 18.2959C28.0748 17.9953 27.5909 17.9953 27.2902 18.2959C26.9999 18.5863 26.9999 19.0702 27.2902 19.3598L32.7421 24.8117H14.7523C14.3329 24.8117 14 25.1459 14 25.5653C14 25.9846 14.3329 26.3285 14.7523 26.3285H32.7415L27.2896 31.7701C26.9993 32.0707 26.9993 32.5553 27.2896 32.8449C27.5903 33.1456 28.0748 33.1456 28.3645 32.8449L35.1067 26.1027C35.4074 25.8124 35.4074 25.3285 35.1067 25.0382L28.3651 18.2959Z" fill="#582200"></path></g><rect x="0.5" y="0.570068" width="49" height="49" rx="24.5" stroke="#582200"></rect><defs><clipPath id="clip0_260_1919"><rect width="21.3332" height="15" fill="white" transform="translate(14 18.0701)"></rect></clipPath></defs></svg>',
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });
  if (window.matchMedia("(max-width: 750px)").matches) {
    $(".article__tag-categories-list").slick({
      dots: false,
      infinite: false,
      speed: 300,
      arrows: true,
      prevArrow:
        '<svg width="50" height="51" viewBox="0 0 50 51" fill="none" data-role="none" class="slick-arrow slick-prev"  style="display: block;"><g clip-path="url(#clip0_260_1916)"><path d="M21.6349 18.2959C21.9252 17.9953 22.4091 17.9953 22.7098 18.2959C23.0001 18.5863 23.0001 19.0702 22.7098 19.3598L17.2579 24.8117H35.2477C35.6671 24.8117 36 25.1459 36 25.5653C36 25.9846 35.6671 26.3285 35.2477 26.3285H17.2585L22.7104 31.7701C23.0007 32.0707 23.0007 32.5553 22.7104 32.8449C22.4097 33.1456 21.9252 33.1456 21.6355 32.8449L14.8933 26.1027C14.5926 25.8124 14.5926 25.3285 14.8933 25.0382L21.6349 18.2959Z" fill="#582200"></path></g><rect x="-0.5" y="0.5" width="49" height="49" rx="24.5" transform="matrix(-1 0 0 1 49 0.0700684)" stroke="#582200"></rect><defs><clipPath id="clip0_260_1916"><rect width="21.3332" height="15" fill="white" transform="matrix(-1 0 0 1 36 18.0701)"></rect></clipPath></defs></svg>',
      nextArrow:
        '<svg width="50" height="51" viewBox="0 0 50 51" fill="none" data-role="none" class="slick-arrow slick-next"  style="display: block;"><g clip-path="url(#clip0_260_1919)"><path d="M28.3651 18.2959C28.0748 17.9953 27.5909 17.9953 27.2902 18.2959C26.9999 18.5863 26.9999 19.0702 27.2902 19.3598L32.7421 24.8117H14.7523C14.3329 24.8117 14 25.1459 14 25.5653C14 25.9846 14.3329 26.3285 14.7523 26.3285H32.7415L27.2896 31.7701C26.9993 32.0707 26.9993 32.5553 27.2896 32.8449C27.5903 33.1456 28.0748 33.1456 28.3645 32.8449L35.1067 26.1027C35.4074 25.8124 35.4074 25.3285 35.1067 25.0382L28.3651 18.2959Z" fill="#582200"></path></g><rect x="0.5" y="0.570068" width="49" height="49" rx="24.5" stroke="#582200"></rect><defs><clipPath id="clip0_260_1919"><rect width="21.3332" height="15" fill="white" transform="translate(14 18.0701)"></rect></clipPath></defs></svg>',
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }
});

// tab js
document.querySelectorAll(".tab_btn").forEach(function (ele) {
  ele.addEventListener("click", function () {
    document.querySelectorAll(".tab_btn").forEach(function (ele) {
      ele.classList.remove("tab_active");
    });
    this.classList.add("tab_active");
    var tabId = this.getAttribute("data-id");
    var filterGrids = document.querySelectorAll(
      ".iwit-content-img-w-info-main"
    );
    filterGrids.forEach(function (filterGrid) {
      var dataId = filterGrid.getAttribute("data-id");
      if (dataId === tabId) {
        filterGrid.classList.add("tab_active");
      } else {
        filterGrid.classList.remove("tab_active");
      }
    });
  });
});
//  impact css
$(".tab_accordian").click(function () {
  $(".tab-accordion__content").slideUp();
  $(".accordion_tab-custom").removeClass("show_tab");
  if ($(this).next(".tab-accordion__content").is(":hidden")) {
    $(this).next(".tab-accordion__content").slideDown();
    $(this).closest(".accordion_tab-custom").addClass("show_tab");
  }
});

$(document).on("click", ".btn_video-content", function () {
  var contentHtml = $(this)
    .closest(".multicolumn-card__info_c")
    .find(".video_content")
    .html();
  $(document).find(".video_content_modal .video_modal").append(contentHtml);
  setTimeout(function () {
    $(document).find(".video_content_modal").addClass("open_modal");
    $("body").addClass("overFlow");
  }, 1000);
});
$(document).on("click", ".video_content_modal .video_close", function () {
  $(document).find(".video_content_modal .video_modal").empty();
  $(document).find(".video_content_modal").removeClass("open_modal");
  $("body").removeClass("overFlow");
});

$(document).on("click", ".btn_video-play", function () {
  var contentHtml = $(this).closest(".media_video").find(".video_hide").html();
  $(document).find(".video_overlay .video_html").append(contentHtml);
  setTimeout(function () {
    $(document).find(".video_overlay").addClass("open_pop");
    $("body").addClass("overFlow");
  }, 1000);
});
$(document).on("click", ".video_overlay .video_close", function () {
  $(document).find(".video_overlay .video_html").empty();
  $(document).find(".video_overlay").removeClass("open_pop");
  $("body").removeClass("overFlow");
});

$(document).on("click", ".play_btn", function () {
  $(this).hide();
  $(this).closest(".video_html").find(".video_id-meta").prop("controls", true);
  var video = $(this).closest(".video_html").find(".video_id-meta")[0];
  video.play();
});

$(document).on("click", ".custom_item-grid", function () {
  $(document).find(".map_popup").addClass("open_Map");
  $(".custom-Map_content").removeClass("open");
  $(".reveal .circleMasks").removeClass("open_svg");
  var dataId = $(this).data("dot");
  $('.reveal .circleMasks[data-dot="' + dataId + '"]').css("r", 200);
  setTimeout(function () {
    $('.custom-Map_content[data-title="' + dataId + '"]').addClass("open");
  }, 200);
});

$(document).on("click", ".close_map", function () {
  $(document).find(".map_popup").removeClass("open_Map");
  $(".custom-Map_content").removeClass("open");
  $(".reveal .circleMasks").css("r", 0);
});

$(".tab_accordian_map").click(function () {
  $(".tab-accordion__content_map").slideUp();
  if ($(this).next(".tab-accordion__content_map").is(":hidden")) {
    $(this).next(".tab-accordion__content_map").slideDown();
  }
});

// our journey

$(".our_journey-grid").slick({
  slidesToShow: 1,
  infinite: false,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  asNavFor: ".our_journey-thumnail",
});
$(".our_journey-thumnail").slick({
  slidesToShow: 1,
  infinite: false,
  slidesToScroll: 1,
  asNavFor: ".our_journey-grid",
  dots: false,
  fade: true,
  arrows: true,
  prevArrow:
    '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="33" height="23" viewBox="0 0 33 23" fill="none"><path d="M31.837 11.134L21.7493 1.36741" stroke="#582200" stroke-width="1.58824" stroke-linecap="round" stroke-linejoin="round"></path><path d="M22.1026 21.6296L31.8433 11.5168" stroke="#582200" stroke-width="1.58824" stroke-linecap="round" stroke-linejoin="round"></path><path d="M32.0259 11.322L1.18183 11.8604" stroke="#582200" stroke-width="1.58824" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
  nextArrow:
    '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="33" height="23" viewBox="0 0 33 23" fill="none"><path d="M31.837 11.134L21.7493 1.36741" stroke="#582200" stroke-width="1.58824" stroke-linecap="round" stroke-linejoin="round"></path><path d="M22.1026 21.6296L31.8433 11.5168" stroke="#582200" stroke-width="1.58824" stroke-linecap="round" stroke-linejoin="round"></path><path d="M32.0259 11.322L1.18183 11.8604" stroke="#582200" stroke-width="1.58824" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
});

$(".our_journey-grid").on(
  "beforeChange",
  function (event, slick, currentSlide, nextSlide) {
    var lastInd = $(".our_journey-thumnail")
      .find(".our_journey-item:last-child")
      .data("slick-index");
    var firstInd = $(".our_journey-thumnail")
      .find(".our_journey-item:first-child")
      .data("slick-index");
    if (lastInd == nextSlide) {
      $(".next_btn").prop("disabled", true);
    } else {
      $(".next_btn").removeAttr("disabled");
    }
    if (nextSlide > 0) {
      $(".prev_btn").removeAttr("disabled");
    } else {
      $(".prev_btn").prop("disabled", true);
    }

    var indexcheck = nextSlide - currentSlide;
    if (indexcheck == "-1") {
      var orl_width = $(".custom_slider_range ul").attr("data-width-orl");
      var onediv_width = $(".custom_slider_range ul").attr("data-width");
      var final_width = parseFloat(orl_width) - parseFloat(onediv_width);
      $(".custom_slider_range ul").attr("data-width-orl", final_width);
      $(".custom_slider_range ul").css(
        "transform",
        "translate(-" + final_width + "px, 0)"
      );
    }
    if (indexcheck == "1") {
      var orl_widths = $(".custom_slider_range ul").attr("data-width-orl");
      var onediv_widths = $(".custom_slider_range ul").attr("data-width");
      var final_widths = parseFloat(orl_widths) + parseFloat(onediv_widths);
      $(".custom_slider_range ul").attr("data-width-orl", final_widths);
      $(".custom_slider_range ul").css(
        "transform",
        "translate(-" + final_widths + "px, 0)"
      );
    }
  }
);

var lastInd = $(".our_journey-thumnail")
  .find(".our_journey-item:last-child")
  .data("slick-index");
$(".our_journey-thumnail").slick("slickGoTo", lastInd);

$(".prev_btn").click(function () {
  var firstInd = $(".our_journey-thumnail")
    .find(".our_journey-item:first-child")
    .data("slick-index");
  $(".our_journey-thumnail").slick("slickGoTo", firstInd);
  $(this).prop("disabled", true);
  $(".next_btn").removeAttr("disabled");
  $(".custom_slider_range ul").attr("data-width-orl", "0");
  $(".custom_slider_range ul").css("transform", "translate(-0px, 0)");
});

$(".next_btn").click(function () {
  var lastInd = $(".our_journey-thumnail")
    .find(".our_journey-item:last-child")
    .data("slick-index");
  $(".our_journey-thumnail").slick("slickGoTo", lastInd);
  $(this).prop("disabled", true);
  $(".prev_btn").removeAttr("disabled");
  var getwidth = $(".custom_slider_range ul").attr("data-item");
  $(".custom_slider_range ul").attr("data-width-orl", getwidth);
  $(".custom_slider_range ul").css(
    "transform",
    "translate(-" + getwidth + "px, 0)"
  );
});

// timeline slider
if (document.querySelectorAll("svg.wavePath g.timeline__circle g").length) {
  document
    .querySelectorAll("svg.wavePath g.timeline__circle g")
    .forEach((ele) => {
      let eleOffset = ele.getBBox();
      let i = ele.dataset.index;
      let eleText = document
        .querySelector('g.timeline__circle text[data-index="' + i + '"]')
        .getBBox();
      let x = eleOffset.x - eleText.width / 2 + 20;
      let y = eleOffset.y + eleOffset.height + 20;
      document
        .querySelector('g.timeline__circle text[data-index="' + i + '"]')
        .setAttribute("x", x);
      document
        .querySelector('g.timeline__circle text[data-index="' + i + '"]')
        .setAttribute("y", y);
    });
}

// product tab

$(".tab_item").each(function () {
  var active,
    content,
    links = $(this).find("a");
  active = links.first().addClass("active_tab");
  content = $(active.attr("href"));
  links.not(":first").each(function () {
    $($(this).attr("href")).hide();
  });
  $(this)
    .find("a")
    .click(function (e) {
      active.removeClass("active_tab");
      content.hide();
      active = $(this);
      content = $($(this).attr("href"));
      active.addClass("active_tab");
      content.show();
      return false;
    });
});

$(document).mouseup(function (e) {
  var container = $(".drawer__inner");
  if (
    !container.is(e.target) &&
    container.has(e.target).length === 0 &&
    $(".drawer.active").length
  ) {
    $(document).find(".drawer__close").trigger("click");
  }
});

// if(location.pathname == '/products/august-basics-box' || location.pathname == '/products/the-full-august-experience'){
let changeSub = setInterval(() => {
  if (document.querySelector(".skio-group-content")) {
    document
      .querySelector(".skio-group-content")
      .closest(".skio-group-label")
      .click();
    let subVal = false;
    if (location.pathname == "/products/august-basics-box") {
      subVal = document.querySelectorAll(".skio-group-content select option")[1]
        .value;
    } else if (location.pathname == "/products/the-full-august-experience") {
      subVal = document.querySelectorAll(".skio-group-content select option")[2]
        .value;
    }
    if (subVal) {
      document.querySelector(".skio-group-content select").value = subVal;
      document
        .querySelector(".skio-group-content select")
        .dispatchEvent(new Event("change"));
    }
    clearInterval(changeSub);
  }
}, 500);
// }

if (document.querySelector(".product__info-wrapper .custom-judge-me-text")) {
  document
    .querySelector(".product__info-wrapper .custom-judge-me-text")
    .addEventListener("click", function () {
      let revTop =
        document.querySelector(
          "body.main-body.its-build-box-product .custom-all-reviews"
        ).offsetTop - 100;
      window.scroll(0, revTop);
    });
}
if (document.querySelector("button.video_frame_close")) {
  document
    .querySelector("button.video_frame_close")
    .addEventListener("click", function () {
      document.querySelector(".video-frame-content-main").style.display =
        "none";
    });
  $(document).on("click", "a.vf-open", function () {
    document.querySelector(".video-frame-content-main").style.display = "block";
  });
}

$(document).ready(function () {
  $(document).on("click", ".build-box-header .bb-reviews", function () {
    $(".build-box-reviews-main .jdgm-sort-dropdown option").each(function () {
      var dropdownOption = $(this).attr("value");
      if (
        dropdownOption == "with-pictures" ||
        dropdownOption == "pictures-first" ||
        dropdownOption == "videos-first"
      ) {
        $(this).hide();
      }
    });
  });

  $(document).on(
    "click",
    ".flip-slide .flip-f-button.flip-frontButton",
    function () {
      $(this)
        .parents(".flip-slide")
        .addClass("flipSlideRotate")
        .siblings()
        .removeClass("flipSlideRotate");
    }
  );

  $(document).on(
    "click",
    ".flip-slide .flip-f-button.flip-BackButton",
    function () {
      $(this).parents(".flip-slide").removeClass("flipSlideRotate");
    }
  );
});

/* Build Box product functionality */
$(document).on("click", ".password_btn button", function () {
  var password = window.b2bPassword;
  var valuePassword = $('.password_input input[type="password"]').val();
  console.log(password);
  console.log(valuePassword);
  if (valuePassword == password) {
    $(".build-box-products-wrapper").show();
    $(".error_password").removeClass("show_error");
    $(".build-box-password").addClass("hide_password");
    $(".build-box-btn-main").show();
    $(".product_description-custom").show();
    pop = "verification";
    setCookie("Product_Password", pop, 365);
    // checkCookie();
  } else {
    $(".build-box-products-wrapper").hide();
    $(".error_password").addClass("show_error");
    $(".build-box-password").removeClass("hide_password");
    $(".build-box-btn-main").hide();
    $(".product_description-custom").hide();
    setTimeout(function () {
      $(".error_password").removeClass("show_error");
    }, 5000);
  }
});

// change prices
document.querySelectorAll(".build-box-qty-sel>select").forEach(function (ele) {
  ele.addEventListener("change", function () {
    let val = this.value;
    let price = Number(this.dataset.price) * Number(this.value);
    let tPrice = moneyFormate(price);
    this.closest(".build-box-product-row").querySelector(
      "span.bbp-total-qty"
    ).textContent = tPrice;
  });
});

var checkBtn = document.querySelector(".card-add-btn.def-build-btn");
if(checkBtn){
  checkBtn.addEventListener("click", function (event) {
    event.preventDefault(); // Prevent page refresh

    let variantsToAdd = [];
    document.querySelectorAll(".build-box-product-row").forEach(function (row) {
      let variantId = row.querySelector("select").getAttribute("data-id");
      let quantity = parseInt(row.querySelector("select").value);

      if (quantity > 0) {
        variantsToAdd.push({
          id: variantId,
          quantity: quantity,
        });
      }
    });

    if (variantsToAdd.length > 0) {
      // Clear the cart first
      clearCart()
        .then(function () {
          addVariantsToCartSequentially(variantsToAdd); // After clearing the cart, add new variants
        })
        .catch(function (error) {
          console.error("Error clearing the cart:", error);
          alert("There was an issue clearing the cart.");
        });
    } else {
     // alert("Please select at least one product.");
    }
  });
}

// Function to clear the cart
function clearCart() {
  return fetch("/cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to clear cart");
      }
      return response.json();
    })
    .then((data) => {
      console.log("Cart cleared:", data);
    });
}

// Function to add variants sequentially to the cart
function addVariantsToCartSequentially(variants) {
  let i = 0;

  function addNextVariant() {
    if (i < variants.length) {
      let variant = variants[i];
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: variant.id,
          quantity: variant.quantity,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error("Failed to add product to cart");
          }
          return response.json();
        })
        .then((data) => {
          console.log("Product added:", data);
          i++;
          addNextVariant(); // Move to the next product
        })
        .catch((error) => {
          console.error("Error adding product to cart:", error);
          alert("There was an issue adding the product to the cart.");
        });
    } else {
      openCartDrawer();
      // alert('success')
      $("cart-drawer").removeClass("is-empty");
      $("#cart-icon-bubble").load(location.href + " #cart-icon-bubble");
      $("cart-drawer").load(location.href + " #CartDrawer");
      setTimeout(function () {
        $("cart-drawer").addClass("active");
      }, 2000);
      setTimeout(function () {
        $(".cart-add-on-products").slick({
          dots: true,
          infinite: false,
          speed: 300,
          arrows: false,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
              },
            },
          ],
        });
      }, 3000);
    }
  }

  addNextVariant(); // Start adding variants one by one
}

// Function to open the cart drawer
function openCartDrawer() {
  const cartDrawer = document.querySelector(".cart-drawer");
  if (cartDrawer) {
    cartDrawer.classList.add("open"); // Trigger the cart drawer to open
  } else {
    console.warn("Cart drawer element not found.");
  }
}
/*
$(document).on("click", ".check-trums input", function () {
  $("button#CartDrawer-Checkout").attr("form", "CartDrawer-Form");
});*/